import { Skeleton } from "@mui/material";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
// import Skeleton from "react-loading-skeleton";

function LoadingItemsGrid() {
  return (
    <Col>
      {/* <Skeleton baseColor="#000" height={50} width={200} />
       <Skeleton height={50} width={200} />

       <Skeleton style={{display:'block'}} height={50} width={200} />
       <Skeleton height={50} width={200} /> */}
      <Container>
        <Row className="gap-3">
          {Array.from({ length: 12 }, () => []).map((i) => (
            <Col key={i} className="border rounded" >
              <Skeleton variant="rectangular" width={120} height={150} style={{ borderRadius:'10px',marginTop:'4px' }} />
              <Skeleton variant="text" width={100} height={30} />
              {/* <br /> */}
              <Skeleton variant="text" width={100} height={10} />
              <Skeleton variant="text" width={80} height={10} />
              <Skeleton variant="text" width={100} height={10} />
              <Skeleton variant="rectangular" width={120} height={30} style={{ borderRadius:'10px',marginBottom:'6px',marginTop:'4px'  }} />


            </Col>
          ))}
        </Row>
      </Container>
    </Col>
  );
}

export default LoadingItemsGrid;
